import React from 'react';
import { cn } from '../../lib/utils';
import { GLASS_BLUR_LEVELS, DEFAULT_GLASS_BLUR } from '../../constants/glass';

/**
 * Glassmorphism card component
 * Used by Forest Classic, Top Heavy, and other glass-card templates.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children
 * @param {string} props.className
 * @param {number} props.blurLevel - Glass blur level index
 * @param {Object} [props.pc] - Palette render colors (from computeRenderColors)
 */
export function GlassCard({ children, className, blurLevel, pc }) {
  const level = GLASS_BLUR_LEVELS[blurLevel ?? DEFAULT_GLASS_BLUR] || GLASS_BLUR_LEVELS[DEFAULT_GLASS_BLUR];
  const isDisabled = blurLevel === 0;

  // When blur is "None", the entire glass card backing disappears:
  // no background, no border, no shadow — just the children.
  if (isDisabled) {
    return (
      <div className={cn('rounded-[28px]', className)}>
        {children}
      </div>
    );
  }

  // Palette-aware tint colors (fallback to white for backward compat)
  const bgColor = pc ? pc.tint(0.006) : 'rgba(255, 255, 255, 0.006)';
  const borderColor = pc ? pc.tint(0.08) : 'rgba(255, 255, 255, 0.08)';

  const style = {
    backdropFilter: `blur(${level.blur})`,
    WebkitBackdropFilter: `blur(${level.blur})`,
    background: bgColor,
    borderColor,
  };

  return (
    <div
      className={cn(
        'rounded-[28px] border',
        'shadow-[0_8px_32px_rgba(0,0,0,0.12)]',
        className
      )}
      style={style}
    >
      {children}
    </div>
  );
}
